import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { Pages } from "components/pages";



export default function GraphicPackingsRoute() {

    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ `${ path }` } exact>
                <Pages.GraphicPackings />
            </Route>
            <Route path={ `${ path }/:graphicPackingID` } >
                { ({ match, history }) => <Pages.GraphicPacking match={ match } history={ history } exact /> }
            </Route>
            <Route path={ `${ path }/create` } exact>
                <Pages.GraphicPacking />
            </Route>
        </Switch>
    );
}